import { Injectable } from '@angular/core';
import { PopupService } from './popup.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerTypeBlockerService {
  constructor(private popupService: PopupService) {}

  blockIfCustomerTypeMismatch(currentUser: any, taskCreatedAsAllocated: boolean): boolean {
    if (!!currentUser?.allocated !== !!taskCreatedAsAllocated) {
      const fromType = taskCreatedAsAllocated
        ? 'allocated customer'
        : 'channel partner customer';
      const toType = currentUser?.allocated
        ? 'allocated customer'
        : 'channel partner customer';

      this.popupService.openAlert(
        `Your customer type has changed from ${fromType} to ${toType}. Consequently, this action cannot be performed. Please redo the tasking.`,
        'warning'
      );
      return true;
    }

    return false;
  }
}
